/**
 * @module New Relic Custom Attribute
 * @description Our New Relic Custom Attribute Snippet
 */
import Script from "next/script";
import { getAsset } from "@/js/utils/helpers";

/**
 * @function NewRelicCustomAttribute
 * @description New Relic Custom Attribute Snippet
 */
const NewRelicCustomAttribute = () => (
  <Script
    src={`${getAsset("/js/nr-custom-attributes.js")}`}
    strategy="afterInteractive"
  />
);

export default NewRelicCustomAttribute;
